import { render } from "./Skills.vue?vue&type=template&id=e7bef2d0&scoped=true&bindings={}"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import "./Skills.vue?vue&type=style&index=0&id=e7bef2d0&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-e7bef2d0"

export default script